<template>
    <div class="invoice-box">
        <Form :label-width="100" label-colon="：">
            <Row>
                <Col span="24">
                    <FormItem label="请扫描">
                        <Input ref="autoFocus" v-model="invoiceInput" placeholder="请切换至英文输入法再扫描" @on-enter="invoiceChange" @on-change="invoiceInputChange"></Input>
                        <!-- <input type="text" ref="autoFocus" v-model="invoiceInput" placeholder="请切换至英文输入法再扫描" class="w-100"> -->
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="发票代码">
                        <Input v-model="splitData.invoiceCode"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="发票号码">
                        <Input v-model="splitData.invoiceNum"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="金额">
                        <Input v-model="splitData.money"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="开票时间">
                        <Input v-model="splitData.invoicingDate"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="校验码">
                        <Input v-model="splitData.checkCode"></Input>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="发票类型">
                        <Select v-model="splitData.invoiceType">
                            <Option :value="0">采购</Option>
                            <Option :value="1">销售</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="所属组织">
                        <Select v-model="splitData.deptName">
                            <Option v-for="item in deptData" :value="item.deptName" :key="item.deptID">{{ item.deptName }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}" class="text-right">
                    <Button type="primary" @click="inStorage">入库</Button>
                </Col>
            </Row>
        </Form>
    </div>
</template>

<script>
import api from '@/api/index';
export default {
    data() {
        return {
            splitData: {
                invoiceCode: '',
                invoiceNum: '',
                money: '',
                invoicingDate: '',
                checkCode: '',
                invoiceType: 0,
                deptName: this.$store.state.deptId
            },
            deptData: [],
            invoiceInput: '',
            invoiceVal: '',
            isChinese: false,
            timer: null
        };
    },
    mounted() {
        this.$refs.autoFocus.focus();
        this.getAllDept();
    },
    methods: {
        invoiceChange() {
            if (this.invoiceInput.indexOf('，') !== -1) {
                this.$Message.warning({
                    background: true,
                    content: '请切换至英文输入法！'
                });
                return;
            }
            this.invoiceVal = this.invoiceInput.toString();
            this.invoiceInput = '';
            this.splitInvoice();
        },
        invoiceInputChange(val) {
            window.clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                if (this.invoiceInput.indexOf('，') !== -1) {
                    this.$Message.warning({ background: true, content: '请切换至英文输入法！' });
                    this.invoiceInput = '';
                }
            }, 300);
        },
        // 处理获取的字符串
        splitInvoice() {
            const sData = this.invoiceVal.split(',');
            if (sData.length < 7) {
                return;
            }
            this.splitData.invoiceCode = sData[2];
            this.splitData.invoiceNum = sData[3];
            this.splitData.money = sData[4];
            if (sData[5].length === 10 && sData[5].indexOf('-') !== -1) {
                this.splitData.invoicingDate = sData[5];
            } else {
                this.splitData.invoicingDate = sData[5].slice(0, 4) + '-' + sData[5].slice(4, 6) + '-' + sData[5].slice(6, 8);
            }
            this.splitData.checkCode = sData[6];
            this.invoiceVal = '';
            this.inStorage();
        },
        // 获取全部组织部
        async getAllDept() {
            const res = await api.getAllDept();
            this.deptData = res.data;
            for (const value of res.data) {
                if (value.deptID === this.$store.state.deptId) {
                    this.splitData.deptName = value.deptName;
                }
            }
        },
        async inStorage() {
            const res = await api.saveInvoice(this.splitData.invoiceCode, this.splitData.invoiceNum, this.splitData.money,
                this.splitData.invoicingDate, this.splitData.checkCode, this.splitData.invoiceType, this.splitData.deptName, localStorage.getItem('CMSUserName'));
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({
                    background: true,
                    content: '入库失败，请尝试手动入库'
                });
                return;
            }
            if (res.data !== null) {
                this.addEnterListener();
                this.$Modal.error({
                    title: '数据已存在',
                    content: '本条数据于 <span class="text-bold">' + res.data.createTime + '</span> 成功入库，操作人 <span class="text-bold">' + res.data.username + '</span>',
                    onOk: () => {
                        this.$refs.autoFocus.focus();
                        this.removeEnterListener();
                    }
                });
            }
        },
        removeEnterListener() {
            document.removeEventListener('keyup', this.enterKey);
        },
        addEnterListener() {
            document.addEventListener('keyup', this.enterKey);
        },
        enterKey(e) {
            if (e.keyCode === 13) {
                this.$Modal.remove();
            }
        }
    }
};
</script>
